import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Text, View } from 'react-native'

import { translate } from '../../../../i18n'
import { useStore } from '../../../../models'
import { timerCountDown } from '../../../../utils/blinds'
import { thousandAbbreviation } from '../../../../utils/thousandAbbreviation'
import { styles } from './BlindsTableStyle'
import { useResponsive } from '@/screens/new-design/hooks'

export const BlindsTable = observer(() => {
  const {
    game: {
      appState,
      blindLevel,
      blindTime,
      remainingTime,
      updatedCurrentBlinds,
      nextBlind,
      isTournamentModeOn,
      startBlindTimer,
      resetTimer,
      isGamePlaying,
      gameStartTime
    }
  } = useStore()

  const { verticalScale } = useResponsive()

  useEffect(() => {
    if (isGamePlaying && blindLevel >= 0 && appState === 'active') {
      startBlindTimer()
    } else {
      resetTimer()
    }
    return () => {
      resetTimer()
    }
    //NOTE: Adding function to dependency causing re-rendering
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGamePlaying, appState])

  const timer = timerCountDown({
    blindTime,
    remainingTime,
    nextSmallBlind: nextBlind.small,
    gameStartTime
  })

  if (!isTournamentModeOn) return null
  return (
    <View style={styles.container}>
      <View style={styles.blind}>
        <Text style={[styles.value, { fontSize: verticalScale(12) }]}>{`${timer.minutes}:${timer.seconds}`}</Text>
        <Text style={[styles.title, { fontSize: verticalScale(12) }]}>{translate('blindsTable.blinds')}</Text>
      </View>
      <View style={styles.blind}>
        <Text style={[styles.value, { fontSize: verticalScale(12) }]}>
          {updatedCurrentBlinds ? (
            <>
              {thousandAbbreviation(updatedCurrentBlinds.small)}/{thousandAbbreviation(updatedCurrentBlinds.big)}
            </>
          ) : null}
        </Text>
        <Text style={[styles.title, { fontSize: verticalScale(12) }]}>{translate('blindsTable.current')}</Text>
      </View>
      <View style={styles.blind}>
        <Text style={[styles.value, { fontSize: verticalScale(12) }]}>
          {thousandAbbreviation(nextBlind.small)}/{thousandAbbreviation(nextBlind.big)}
        </Text>
        <Text style={[styles.title, { fontSize: verticalScale(12) }]}>{translate('blindsTable.next')}</Text>
      </View>
    </View>
  )
})
